import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { RTTempPriceResponse } from '@/types/api';

export function useRTTempPrice() {
  return useQuery({
    queryKey: ['rt-temp-price', 'data'],
    queryFn: async () => {
      const res = await apiClient.get<RTTempPriceResponse>('/rt-temp-price/data');
      return res.data;
    },
    staleTime: 30 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    refetchInterval: 60 * 1000,
  });
}
